import { useDispatch } from "react-redux";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";

export const useDeleteVariantDraft = (id?: string) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      dispatch(
        apiThatThrows.deleteTiVoVariantDraft.action({
          params: { id },
        })
      ),
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: ["providers"] }),
        queryClient.invalidateQueries({ queryKey: ["variantDraft", id] }),
        queryClient.invalidateQueries({ queryKey: ["provider", id] }),
      ]),
  });
};
